import React, { PureComponent } from "react";
import { createPortal } from 'react-dom';
import { Radio, Spin } from "antd";
import Panel from '@/components/Panel';
import { getPanelMaxWidth, getPanelWidth } from '@/services/helper/panelSizeHelper';
import { getServiceConfig, updateProjectServiceConfig } from "../../../../services/Andes_v2/project";
import "./index.css"

const ASIV_INTERPOLATION_METHOD = "asivInterpolationMethod";
const radioOptions = [
  { label: "Cubic spline interpolation", value: "CUBIC_SPLINE" },
  { label: "Linear interpolation", value: "LINEAR" }
]

class AdvanceOptionPanel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      maxWidth: 660,
      options: { options: {} },
      loading: true
    }
    this.dialogRoot = document.getElementById('root');
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxWidth: getPanelMaxWidth(offset, 660)
    })
  }

  async componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
    const options = await getServiceConfig(this.props.projectId);
    this.setState((prevState) => {
      return { options: options || prevState.options, loading: false };
    })
  }

  handleChange = (value) => {
    const { options } = this.state;
    this.setState({ options: { ...options, options: { ...options.options, [ASIV_INTERPOLATION_METHOD]: value } } })
  }

  closeModal = async () => {
    const { options } = this.state;
    const { projectId } = this.props;
    await updateProjectServiceConfig({ projectId, options });
    this.props.closePanel();
  }

  render() {
    const { maxWidth, options: { options = {} }, loading } = this.state;
    const content = (
      <Panel
        className='advance-option-panel aurora-x-scroll-hidden'
        title={<div className='service-option-title'>Advanced Option</div>}
        onCancel={this.closeModal}
        zIndex={2000}
        width={getPanelWidth(maxWidth, { defaultWidth: 660 })}
        position='panel-center'
        draggable
        minHeight={140}
        minWidth={200}
      >
        <div className='advance-option-content'>
          <Spin spinning={loading} tip={loading ? `Loading...` : ''}>
            <div className="advance-option-div-title">S-Parameter Cascade Interpolation Algorithm</div>
            <Radio.Group
              className="advance-option-radio-group"
              value={loading ? "" : (options[ASIV_INTERPOLATION_METHOD] || "LINEAR")}
              options={radioOptions}
              onChange={(e) => this.handleChange(e.target.value)}
            />
          </Spin>
        </div>
      </Panel >
    )
    return createPortal(content, this.dialogRoot);
  }
}

export default AdvanceOptionPanel;